import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42fa2347"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]

import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'Content',
  setup(__props) {

const route = useRoute()
const router = useRouter()
// console.log('playerList', route.params.playerList);
if (!route.params.playerList) {
    console.log('无参数')
    router.push('/')
}
let playerList = JSON.parse(route.params.playerList as string)
let currentPlayer = JSON.parse(route.params.currentPlayer as string)
console.log('playerList', playerList)

const pagePath = ref('reports/' + currentPlayer.playerName + '.html')
const btnTxt = ref('查看下一个球员')

if (currentPlayer.playerName === playerList[playerList.length - 1].playerName) {
    btnTxt.value = '回到首页'
}

const next = () => {
    for (let i = 0; i < playerList.length; i++) {
        const player = playerList[i]
        if (player.playerName === currentPlayer.playerName) {
            if (i < playerList.length - 1) {
                currentPlayer = playerList[i + 1]
                // console.log('currentPlayer===', currentPlayer);

                pagePath.value = 'reports/' + playerList[i + 1].playerName + '.html'
                if (i === playerList.length - 2) {
                    btnTxt.value = '回到首页'
                }
                break
            }
            if (i == playerList.length - 1) {
                router.push({
                    name: 'china-team',
                })
            }
        }
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("iframe", {
        class: "iframe",
        src: pagePath.value,
        frameborder: "0"
      }, null, 8, _hoisted_1)
    ]),
    _createElementVNode("div", {
      class: "next-button",
      onClick: next
    }, _toDisplayString(btnTxt.value), 1)
  ]))
}
}

})